const DEFAULT_MOUNT_ID = "modal-mount-node";

export function getDefaultMountNode(): HTMLElement | null {
  if (typeof document === "undefined") {
    return null;
  }
  return document.getElementById(DEFAULT_MOUNT_ID) ?? document.body;
}
